import { AnalyticsEventType, SourceType } from '@wix/answers-api';

import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();
const locale = renderModel.getLocale();

export const logArticleView = (id: string, httpClient: HttpClientFactory) => {
  try {
    httpClient.getInstance().post(`${clientTopology.answersAnalyticsURL}`, {
      type: AnalyticsEventType.PAGE_VIEW,
      locale,
      itemId: id,
      sourceType: SourceType.WIDGET,
      sourceId: null,
    });
  } catch (error) {
    logger.log({
      message: `fail to log article view: ${id}`,
      error,
    });
    console.error(error);
  }
};
